import './Account.css'
import { useState, useCallback } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Header } from '../../components/Header/Header.js'
import { ReactComponent as ArrowFollow } from '../../icon/arrow-follow.svg'
import { ReactComponent as EditBlue } from '../../icon/edit_blue.svg'
import { BottomMenu } from '../../components/BottomMenu/BottomMenu'
import { ReactComponent as Done } from '../../icon/done.svg'
import { ReactComponent as Cross } from '../../icon/close.svg'
import GlobalStore from '../../GlobalStore'
import { useUpdateCommunityMutation } from '../../redux/communityService/communityApiSlice'

export default function Account() {
	const { t } = useTranslation()
	const location = useLocation()
	const [updateCommunity] = useUpdateCommunityMutation()
	const { communityName, communityUid } = GlobalStore.getStore()
	const [editMode, setEditMode] = useState(false)
	const [name, setName] = useState(communityName)

	const handleEditionDone = useCallback(async () => {
		setEditMode(false)
		if (!name?.replace(' ', '') || name === communityName) {
			setName(communityName)
			return
		}

		const body = {
			name: name,
			country_code: 'ru'
		}

		try {
			const response = await updateCommunity({ community_uid: communityUid, body }).unwrap()

			if (response?.error) {
				return
			} else {
				GlobalStore.setItem('communityName', name)
			}
		} catch (e) {
			console.log('Community update catched error', e)
		}
	}, [name, updateCommunity, communityUid, communityName])

	const handleEditionClose = useCallback(() => {
		setEditMode(false)
		setName(communityName)
	}, [communityName])

	return (
		<>
			<Header
				title={t('Account')}
				settingsButton={true}
				location={location}
			/>

			<div className="account__wrapper">
				<div className="account__block">

					<div
						className="account__communities-content"
						style={{ border: !editMode ? '1px solid #CCCCCC' : '1px solid #367BCF' }}
					>
						<div className="account__communities-container">
							{
								!editMode ?
									<p className="account__communities-item__name">
										{name}
									</p>
									:
									<input
										value={name}
										onChange={e => setName(e.target.value)}
										className="account__communities-item__name-input"
										maxLength={'16'}
									/>
							}

							{
								!editMode ?
									<EditBlue onClick={() => setEditMode(true)} className="edit-icon" />
									:
									<div className="account__icons-edition">
										<div onClick={() => handleEditionDone()} className="account__icon-done">
											<Done />
										</div>
										<div onClick={() => handleEditionClose()} className="account__icon-close">
											<Cross />
										</div>
									</div>
							}
						</div>
					</div>
				</div>

				<div className="account__block">
					<div className="account__menu">
						<Link to="/account/venues" className="account__menu-links account__menu-links--border">
							<p className="account__menu-links__item-subtitle">
								{t('Venues')}
							</p>

							<ArrowFollow className="account__menu-links__item-icon" />
						</Link>

						<Link to="/account/players" className="account__menu-links">
							<p className="account__menu-links__item-subtitle">
								{t('Players')}
							</p>

							<ArrowFollow className="account__menu-links__item-icon" />
						</Link>

						{/*
						<Link to="/account/categories" className="account__menu-links links--border">
							<p className="account__menu-links__item-subtitle">
								{t("Tournament categories")}
							</p>

							<ArrowFollow className="account__menu-links__item-icon" />
						</Link>
						*/}
					</div>
				</div>
			</div>

			<BottomMenu />
		</>
	)
}